module.exports = __webpack_public_path__ + "65777840e000eebd671696fceb66e9da.png";